import { render, staticRenderFns } from "./InvoiceTable.vue?vue&type=template&id=4ba91ee7"
import script from "./InvoiceTable.vue?vue&type=script&lang=js"
export * from "./InvoiceTable.vue?vue&type=script&lang=js"
import style0 from "./InvoiceTable.vue?vue&type=style&index=0&id=4ba91ee7&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports